import React from 'react';
export default function Research() {
  return <div style={{ color: '#fff', padding: 24 }}>RESEARCH</div>;
}